import { UserManager, WebStorageStateStore, User, UserProfile } from 'oidc-client-ts'
import { CognitoIdentityProviderClient, InitiateAuthCommand } from '@aws-sdk/client-cognito-identity-provider'
import configuration from '../configuration/Configuration'
import { isWeb } from '../../app/utils';

const userManagerSettings = {
  authority: configuration.idp,
  client_id: configuration.cognitoClientId,
  redirect_uri: isWeb()
    ? `${window.location.origin}${window.location.search}`
    : 'https://meraki-innovation.it',
  response_type: 'code',
  scope: 'email openid profile aws.cognito.signin.user.admin',
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
}

export const userManager: UserManager = new UserManager(userManagerSettings)

function decodeJwtPayload(token: string): UserProfile {
  try {
    const payload = token.split('.')[1]
    const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
    return JSON.parse(json) as UserProfile
  } catch {
    return {} as UserProfile
  }
}

export async function cognitoSignin(username: string, password: string): Promise<void> {
  const client = new CognitoIdentityProviderClient({ region: configuration.region })
  const command = new InitiateAuthCommand({
    AuthFlow: 'USER_PASSWORD_AUTH',
    ClientId: configuration.cognitoClientId,
    AuthParameters: {
      USERNAME: username,
      PASSWORD: password,
    },
  })

  const response = await client.send(command)

  if (response.ChallengeName === 'NEW_PASSWORD_REQUIRED') {
    throw new Error(
      'È necessario impostare una nuova password. Usa il link "Password dimenticata".'
    )
  }
  if (response.ChallengeName) {
    throw new Error(`Autenticazione non supportata: ${response.ChallengeName}`)
  }

  const result = response.AuthenticationResult
  if (!result?.IdToken || !result?.AccessToken) {
    throw new Error('Risposta di autenticazione non valida.')
  }

  const profile = decodeJwtPayload(result.IdToken)
  const user = new User({
    id_token: result.IdToken,
    access_token: result.AccessToken,
    refresh_token: result.RefreshToken,
    token_type: 'Bearer',
    scope: userManagerSettings.scope,
    profile,
    expires_at: Math.floor(Date.now() / 1000) + (result.ExpiresIn ?? 3600),
    session_state: null,
  })

  await userManager.storeUser(user)
  await userManager.events.load(user)
}
